import { durableStorage } from '@/lib/durableStorage';
import { triggerBlobDownload } from '@/utils/download';
import { noSecureStorage } from './secureStorage';
import type { Platform, PlatformNetwork, Unsubscribe } from './types';

const noop: Unsubscribe = () => {};

export const browserNetwork: PlatformNetwork = {
  isOnline: () => navigator.onLine,
  onChange: (listener) => {
    const online = () => listener(true);
    const offline = () => listener(false);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);
    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  },
};

/**
 * The website as it has always behaved: links open in the browser itself and a
 * tab coming back into view is handled by the existing `online` listeners.
 */
export const webPlatform: Platform = {
  kind: 'web',
  storage: durableStorage,
  authTransport: 'cookie',
  secureStorage: noSecureStorage,
  network: browserNetwork,
  deepLinks: { subscribe: () => noop },
  lifecycle: { onResume: () => noop, onBackButton: () => noop, exit: async () => {} },
  app: { info: async () => null },
  browser: {
    open: async (url) => {
      window.open(url, '_blank', 'noopener,noreferrer');
    },
  },
  files: {
    save: async (blob, filename) => {
      triggerBlobDownload(blob, filename);
      return 'saved';
    },
  },
  // The website keeps its own behavior: no wake lock, no vibration.
  device: { keepAwake: async () => {}, allowSleep: async () => {}, tapFeedback: async () => {}, name: async () => null },
};
